import styled, { css } from 'styled-components'
import { BREAKPOINT_SM } from '../../theme/ota'

type Active = {
  active?: boolean
  disableMarginBottom?: boolean
  borderBottom?: boolean
}

export const Container = styled.div<Active>`
  width: 100%;
  height: 36px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  border-bottom: 1px solid #e4e4e4;
  margin-bottom: ${({ disableMarginBottom }) => (disableMarginBottom ? 'unset' : '15px')};

  @media (max-width: calc(${BREAKPOINT_SM})) {
    height: auto;
    padding: 0 10px;
    align-items: unset;
    flex-direction: column;
    justify-content: unset;
  }
`

export const Bar = styled.div<Active>`
  gap: 10px;
  display: flex;
  flex-flow: row nowrap;

  @media (max-width: calc(${BREAKPOINT_SM})) {
    ${({ borderBottom }) =>
      borderBottom &&
      css`
        border-bottom: 1px solid #e4e4e4;
      `}
  }
`

export const BarItem = styled.div<Active>`
  gap: 5px;
  display: flex;
  cursor: pointer;
  padding: 0 10px 5px;
  align-items: center;
  justify-content: space-between;
  border-bottom: ${({ active, theme }) => (active ? `2px solid ${theme.colors.primary}` : 'none')};
`

export const BarText = styled.p<Active>`
  margin: 0;
  font-size: 12px;
  line-height: 17px;
  font-weight: bold;
  color: ${({ active, theme }) => (active ? theme?.colors?.primary : theme?.colors?.textColor)};
`
